import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  standalone: false
})
export class TruncatePipe implements PipeTransform {
  transform(value: number, decimalPlaces = 1): string {
    const factor = Math.pow(10, decimalPlaces);
    const truncatedValue = Math.floor(value * factor) / factor;
    return truncatedValue.toFixed(decimalPlaces);
  }
}
